export default __webpack_public_path__ + "static/property-cfc61f2fafffdd23ab0890183709bd0c.jpg";